import { addClass } from "ak-react-components";
import styles from "./LinkButton.module.scss";

const LinkButton = addClass("button", styles.linkButton);

export default LinkButton;
